import { useTranslation } from 'react-i18next';
import { cn } from '@recipes/ui';
import { usePublicConfig } from '@/lib/hooks/use-public-config';

/**
 * Legal notice and privacy policy – hosted by the identity service for every FAPS application
 * (`LEGAL_URL`). Renders nothing while the server names no addresses.
 */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation();
  const legal = usePublicConfig().data?.legal;
  if (!legal) return null;
  return (
    <nav
      aria-label={t('legal.imprint')}
      className={cn('flex flex-wrap gap-4 text-xs text-muted-foreground', className)}
      data-testid="legal-links"
    >
      <a href={legal.imprintUrl} className="hover:underline" target="_blank" rel="noreferrer">
        {t('legal.imprint')}
      </a>
      <a href={legal.privacyUrl} className="hover:underline" target="_blank" rel="noreferrer">
        {t('legal.privacy')}
      </a>
    </nav>
  );
}
